import { nanoid } from "nanoid";
import { mdRenderData } from '../markdown/MarkdownConverter';
import { resetQuestionStandardAnswer, resetAnswer } from "./AnswerService"
import { count } from "d3";

const QUESTION_DEFAULTS = {
    showAnserPanel: false,
    isLoading: false,
    pointFormVisible: false,
    collectFormVisible: false,
    isAnswered: false,
    roughPaperShow: false,
    answerHtml: "",
    teacher_expl: "",
};
const options = ["A", "B", "C", "D"]


export function initQuestion(questions, type, replaceIdx) {
    let qObject = {
        SCQ: {
            questions: [],
            count: 0
        },
        MCQ: {
            questions: [],
            count: 0
        },
        TF: {
            questions: [],
            count: 0
        },
        FIB: {
            questions: [],
            count: 0
        },
        SQ: {
            questions: [],
            count: 0
        }
    }
    questions.forEach(q => {
        let nid = nanoid(5)
        resetQuestionStandardAnswer(q);
        resetAnswer(q, "viewAnswer");
        let question = {
            ...QUESTION_DEFAULTS,
            ...q,
            nanoid: nid,
            isCollapse: q.id,
            isCollected: type === 'questionCollect' ? true : false,
            userAnswer: q.question_type === 'MCQ' ? [] : "",
            knowledgePoint: q.knowledgePoint ? q.knowledgePoint : "",
            question: processQuestionText(q.question, replaceIdx, type),
            option: processOptions(q.option, type),
            collectReplace: {},
            isStandardEpxlCollapse: nid + "answer_expl",
            // 是否要折叠老师讲解面板
            isTeacherEpxlCollapse: nid + "teacher_expl",
            // 是否要折叠查看答案的面板
            isViweAnswerCollapse: nid + "view_answer",
        }
        if (!qObject[question.question_type]) {
            qObject[question.question_type] = {
                questions: [],
                count: 0
            }
        }
        qObject[question.question_type].questions.push(question)
    });

    resetQuestionIndex(qObject)
    return qObject
}

export function initQuestionForList(questions, type) {
    return questions.map(q => {
        let nid = nanoid()
        let questionText = mdRenderData(q.question.replace(/(\d+)\./, ''));
        resetQuestionStandardAnswer(q);
        resetAnswer(q, "viewAnswer");
        return {
            ...QUESTION_DEFAULTS,
            ...q,
            nanoid: nid,
            isCollapse: q.id,
            isCollected: type === 'questionCollect' ? true : false,
            userAnswer: q.question_type === 'MCQ' ? [] : "",
            knowledgePoint: q.knowledgePoint ? q.knowledgePoint : "",
            question: questionText,
            option: processOptions(q.option, type),
            collectReplace: {},
            isStandardEpxlCollapse: nid + "answer_expl",
            // 是否要折叠老师讲解面板
            isTeacherEpxlCollapse: nid + "teacher_expl",
            // 是否要折叠查看答案的面板
            isViweAnswerCollapse: nid + "view_answer",
        }

    });
}

export function resetQuestionIndex(qObject) {
    qObject.MCQ.count = qObject.SCQ.questions.length;
    qObject.TF.count = qObject.MCQ.count + qObject.MCQ.questions.length;
    qObject.FIB.count = qObject.TF.count + qObject.TF.questions.length;
    qObject.SQ.count = qObject.FIB.count + qObject.FIB.questions.length;
}

function processQuestionText(question, replaceIdx, type) {
    // 处理文本的逻辑...
    if (replaceIdx >= 0) {
        if (type === 'collectReplace') {
            // 弹窗收藏面板的已经渲染过了
            return replaceStartNumbers(question, replaceIdx + 1)
        } else {
            return mdRenderData(`${replaceIdx + 1}. ` + question)
        }
    } else {
        let q = question.replace(/(\d+)\./, '');
        return mdRenderData(q)
    }
}

function processOptions(option, type) {
    if (option) {
        // 根据收藏本替换不用再渲染选项了，因为已经渲染过了
        if (type === 'collectReplace') {
            return option
        }
        return option.map((item, idx) =>
            mdRenderData(options[idx] + '、' + item)
        )
    }
}
export function replaceStartNumbers(olString, startNumber) {
    const regex = /<ol(\s+start="\d+")?\s*>/g;
    const replacedString = olString.replace(regex, `<ol start="${startNumber}"$1>`);
    return replacedString;
}

